import { useEffect } from "react";

const SITE = "Chinmaya Sharma";
const DEFAULT_TITLE = "Chinmaya Sharma — Writer · Director · Producer";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_media-portfolio-95/artifacts/fm5n2gjt_hero%20index.jpg";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const usePageMeta = ({ title, description, image } = {}) => {
  useEffect(() => {
    const full = title ? `${title} — ${SITE}` : DEFAULT_TITLE;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", image || DEFAULT_IMAGE);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image || DEFAULT_IMAGE);
  }, [title, description, image]);
};
